
<template lang="pug">
.shifts-surplus-mark(:style="{color: surplus.color}") {{surplus.mark}}
</template>

<script>
export default {
  props: {
    value: Number,
  },

  computed: {
    surplus() {
      return this.value == null ? {color: 'black', mark: ''} :
            (this.value < -20 ? {color: 'red',   mark: 'Ｘ'} :
            (this.value < -10 ? {color: 'red',   mark: '▽'} :
            (this.value <  10 ? {color: 'black', mark: '○'} :
            (this.value <  20 ? {color: 'black', mark: '△'} :
                                {color: 'black', mark: 'Ｘ'}))))
    },
  },
}
</script>

<style lang="sass">
.shifts-surplus-mark
  font-family: 'ヒラギノ角ゴシック', 'Hiragino Sans', 'ヒラギノ角ゴ ProN W3', 'Hiragino Kaku Gothic ProN', 'メイリオ', 'Meiryo', 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif
  font-size: 1.4rem
  padding-top: 2px
</style>
